import React, { useContext, useState, useEffect } from "react";
import {
  getAuth,
  onAuthStateChanged,
  signInWithCustomToken,
  signOut,
} from "firebase/auth";
import { Spinner } from "react-bootstrap";

const AuthContext = React.createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      //console.log("on auth state changed: " + JSON.stringify(user));
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const authSignIn = (customToken) => {
    signInWithCustomToken(auth, customToken).then((res) => {
      //console.log("sigin result: " + JSON.stringify(res));
    });
  };

  const authSignOut = async (message) => {
    return signOut(auth).then(() => {
      //console.log(message);

      /* also signout web */
      //console.log("alos signout web");
    });
  };

  const value = {
    currentUser,
    authSignIn,
    authSignOut,
  };

  return (
    <AuthContext.Provider value={value}>
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      {!loading && children}
    </AuthContext.Provider>
  );
};
